/* ============================================
   New Login Mixin
   ============================================
   包含 new-login 组件中重复使用的逻辑
   用于减少代码重复，便于维护
   ============================================ */

import { validateEmail, validateMobile, checkPasswordStrength } from './utils.js';

export default {
  methods: {
    /**
     * 统一的错误清除方法
     * @param {string} errorPropertyName - 错误属性名称
     */
    clearError(errorPropertyName) {
      if (this[errorPropertyName] !== undefined) {
        this[errorPropertyName] = false;
      }
    }
  },
  computed: {
    /**
     * 统一的邮箱验证计算属性
     * 子组件可以通过 props 传入 email 值来使用
     */
    isValidEmailComputed() {
      return (email) => {
        return validateEmail(email || '');
      };
    }
  }
};

